<div class="abb-container">
  <h1 class="page-title">{{ "subscription.title" | translate }}</h1>

  <div *ngIf="loadingSub" class="abb-loading">{{ "common.loading" | translate }}</div>

  <ng-container *ngIf="!loadingSub && sub">
    <!-- Riepilogo piano corrente -->
    <section class="current-card">
      <div class="current-head">
        <div class="current-plan">
          <span class="plan-badge" [class.paid]="isSubscribed">{{ planLabel() }}</span>
          <span class="plan-status">{{ statusLabel() }}</span>
        </div>
        <div class="current-meta">
          <p *ngIf="sub.status === 'trial' && sub.trialEndsAt" class="meta-line">
            {{ "subscription.trial_until" | translate }} <strong>{{ sub.trialEndsAt | date:'dd/MM/yyyy' }}</strong>
          </p>
          <p *ngIf="isSubscribed && !sub.cancelAtPeriodEnd && sub.currentPeriodEnd" class="meta-line">
            {{ "subscription.renews_on" | translate }} <strong>{{ sub.currentPeriodEnd | date:'dd/MM/yyyy' }}</strong>
          </p>
          <p *ngIf="isSubscribed && sub.cancelAtPeriodEnd && sub.currentPeriodEnd" class="meta-line warn">
            {{ "subscription.active_until" | translate }} <strong>{{ sub.currentPeriodEnd | date:'dd/MM/yyyy' }}</strong>{{ "subscription.no_renew" | translate }}
          </p>
        </div>
      </div>

      <!-- Gestione in-app -->
      <div *ngIf="isSubscribed" class="current-actions">
        <button
          *ngIf="!sub.cancelAtPeriodEnd"
          class="btn-outline btn-cancel-sub"
          [disabled]="processing !== null"
          (click)="cancelSubscription()"
        >
          {{ processing === 'cancel' ? '…' : ("subscription.cancel_title" | translate) }}
        </button>
        <button
          *ngIf="sub.cancelAtPeriodEnd"
          class="btn-solid"
          [disabled]="processing !== null"
          (click)="reactivateSubscription()"
        >
          {{ processing === 'reactivate' ? '…' : ("subscription.reactivate" | translate) }}
        </button>
      </div>
    </section>

    <!-- Banner beta: vendita disattivata -->
    <div *ngIf="!checkoutEnabled" class="beta-banner">
      <span class="beta-banner-icon"><app-icon name="sparkle" [size]="20" /></span>
      <p class="beta-banner-text">{{ "subscription.beta_banner" | translate }}</p>
    </div>

    <!-- Scelta / cambio piano -->
    <h2 class="section-title">{{ (isSubscribed ? "subscription.change_plan" : "subscription.choose_plan") | translate }}</h2>
    <div class="plan-grid" #planGrid>
      <div
        *ngFor="let p of plans"
        class="plan-card"
        [class.highlight]="p.highlight"
        [class.current]="isCurrentPlan(p.key)"
      >
        <div *ngIf="p.highlight" class="plan-ribbon">{{ "subscription.recommended" | translate }}</div>
        <div class="plan-top">
          <span class="plan-name">{{ p.label }}</span>
          <div class="plan-price"><span class="amount">{{ p.price }}</span> €<span class="per">{{ "subscription.per_month" | translate }}</span></div>
        </div>
        <ul class="plan-features">
          <li *ngFor="let f of p.features">{{ "subscription.features." + f | translate }}</li>
        </ul>
        <button
          class="plan-cta"
          [class.ghost]="isCurrentPlan(p.key)"
          [disabled]="processing !== null || isCurrentPlan(p.key)"
          (click)="choosePlan(p.key)"
        >
          <ng-container *ngIf="isCurrentPlan(p.key)">{{ "subscription.current_plan" | translate }}</ng-container>
          <ng-container *ngIf="!isCurrentPlan(p.key)">
            <ng-container *ngIf="processing === p.key">…</ng-container>
            <ng-container *ngIf="processing !== p.key">
              <ng-container *ngIf="checkoutEnabled">{{ (isSubscribed ? "subscription.switch_to" : "subscription.subscribe") | translate: { plan: p.label } }}</ng-container>
              <ng-container *ngIf="!checkoutEnabled">{{ "subscription.request_activation" | translate }}</ng-container>
            </ng-container>
          </ng-container>
        </button>
      </div>
    </div>

    <p class="abb-note" *ngIf="checkoutEnabled">{{ "subscription.note_stripe" | translate }}</p>
    <p class="abb-note" *ngIf="!checkoutEnabled">{{ "subscription.note_beta" | translate }}</p>
  </ng-container>
</div>
